import getInstantWinCardDetail from "./getInstantWinCardDetail.api";
import getAvailableInstantWinDropdown from "./getAvailableInstantWinDropdown.api";
import getInstantWinCardDetailList from "./getInstantWinCardDetailList.api";

const instantWinApi = {
  getInstantWinCardDetail,
  getAvailableInstantWinDropdown,
  getInstantWinCardDetailList,
};

export default instantWinApi;
